import { CtrlType } from "@yuigoto/ctrl";

export const RegisterControl = [
  {
    name: "email",
    label: "E-mail (insira um e-mail válido)",
    type: CtrlType.EMAIL,
    placeholder: "mail@mail.com",
    required: true,
    value: "",
    emailMessage: "Endereço de e-mail inválido",
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "firstName",
    label: "Nome",
    type: CtrlType.DEFAULT,
    required: true,
    value: "",
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "lastName",
    label: "Sobrenome",
    type: CtrlType.DEFAULT,
    required: true,
    value: "",
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "cpf",
    label: "CPF",
    type: CtrlType.CPF,
    required: true,
    value: "",
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "password",
    label: "Senha",
    type: CtrlType.PASSWORD,
    placeholder: "••••••••",
    required: true,
    value: "",
    requiredMessage: "Este campo é obrigatório",
    minLength: 4,
    minLengthMessage: "A senha deve conter no mínimo 4 caracteres"
  },
  {
    name: "passwordConfirmation",
    label: "Confirmar senha",
    type: CtrlType.PASSWORD,
    placeholder: "••••••••",
    required: true,
    value: "",
    requiredMessage: "Este campo é obrigatório",
    minLength: 4,
    minLengthMessage: "A senha deve conter no mínimo 4 caracteres"
  },
  {
    name: "newsletterOptIn"
    , label: "Newsletter"
    , type: CtrlType.BOOLEAN
    , description: "Aceito receber comunicações da Glambox por e-mail ou outros meios."
    , custom: true
    , value: true
  }
];
